<template>
  <div class="icon-provider icon-provider--notes"></div>
</template>

<script>
export default {
  props: ['providerId'],
};
</script>

<style lang="scss">
.icon-provider {
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.icon-provider--notes {
  background-image: url(../assets/iconNotes.svg);

  @media (prefers-color-scheme: dark) {
    background-image: url(../assets/iconNotesDark.svg);
  }
}
</style>
